'use client';

import { useMemo } from 'react';
import { useFetcherCSR } from '@/lib/useFetcherCSR';
import { API_YOUTUBE_VIDEOS_ORIENTATION } from '@/constant/apiRout';
import { ShortsSlider } from './ShortsSlider';
import { ShortsSliderSkeleton } from './ShortsSliderSkeleton';

interface Product {
  id: number;
  thumbnail_image: string;
  name: string;
  slug: string;
  price: number;
  sale_price: number;
}

interface ShortVideo {
  slug: string;
  banner?: string;
  title?: string;
  products?: Product[];
}

const HomeShortsSlider = () => {
  const { data, isLoading, error } = useFetcherCSR(
    API_YOUTUBE_VIDEOS_ORIENTATION('shorts', 'order_by=latest')
  );

  const shorts = useMemo<ShortVideo[]>(() => {
    const items = Array.isArray(data?.data) ? data.data : [];

    return items.map((item: any) => ({
      ...item,
      products: Array.isArray(item?.products)
        ? item.products
        : [],
    }));
  }, [data]);

  if (isLoading) {
    return <ShortsSliderSkeleton />;
  }

  if (error) {
    const errorMessage =
      typeof error === 'string'
        ? error
        : (error as any)?.message || 'Failed to load shorts';

    return (
      <div className="text-center py-4 text-danger">
        {errorMessage}
      </div>
    );
  }

  if (shorts.length === 0) {
    return null;
  }

  return <ShortsSlider shorts={shorts} />;
};

export default HomeShortsSlider;